import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import stylex from '@stylexjs/stylex';
import baseTheme from '../../themes/base/theme.json';
import { ThemeContext } from './Theme.context';
import { themeProviderStyles } from './ThemeProvider.styles';
import { ThemeSetterContext, } from './ThemeSetter.context';
// import { ResponsiveStyles } from './ResponsiveStyles';
export const ThemeProvider = (props) => {
    const { sx, children, theme: defaultTheme, settings, componentsStyles, ...other } = props;
    const [dynamicTheme, setDynamicTheme] = useState();
    const theme = {
        ...baseTheme,
        ...defaultTheme,
        ...dynamicTheme,
    };
    const themeSetterContextValue = useMemo(() => ({ setTheme: setDynamicTheme }), []);
    return (_jsx(ThemeSetterContext.Provider, { value: themeSetterContextValue, children: _jsx(ThemeContext.Provider, { value: {
                theme,
                settings,
                componentsStyles,
            }, children: _jsx("div", { ...other, ...stylex.props([
                    theme?.scale && themeProviderStyles.dynamicScale(theme.scale),
                    theme?.density && themeProviderStyles.dynamicDensity(theme.density),
                    theme?.schemes &&
                        themeProviderStyles.dynamicScheme(theme.schemes.light),
                    theme?.shape && themeProviderStyles.dynamicShape(theme.shape),
                    theme?.motion && themeProviderStyles.dynamicMotion(theme.motion),
                    theme?.typeFace &&
                        themeProviderStyles.dynamicTypeFace(theme.typeFace),
                    theme?.typeScale &&
                        themeProviderStyles.dynamicTypeScale(theme.typeScale),
                    theme?.state && themeProviderStyles.dynamicState(theme.state),
                    theme?.zIndex && themeProviderStyles.dynamicZIndex(theme.zIndex),
                    theme?.outline && themeProviderStyles.dynamicOutline(theme.outline),
                    themeProviderStyles.wrapper,
                    sx,
                ]), children: _jsx("div", { id: 'sixui-root', children: children }) }) }) }));
};
